import Vue from 'vue'
import Constants from 'Constants'
import RootMarketplaceMixin from 'GroomyRoot/mixins/Marketplace.js'


export default Vue.util.mergeOptions(RootMarketplaceMixin, {
    methods: {
        /**
         * Vérifie le statut d'un paiement marketplace (duedates ou invoice details).
         * @param {string} type - 'duedates' ou 'details'
         * @param {Array<number>} ids - Identifiants des duedates ou invoice details.
         * @returns {Object|null} { status: 'success'|'pending'|'error', invoice_ids: [...] }
         */
        checkMarketplacePaymentResult: async function(type, ids) {
            const url = Constants.MARKETPLACE_PAYMENT_RESULT_URL + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("MarketplaceMixin::checkMarketplacePaymentResult", url, { type, ids }, false)
                .catch(error => {
                    console.error("MarketplaceMixin::checkMarketplacePaymentResult => ERROR", error)
                    return null
                })
            if (result && result.retour) return result.retour
            return null
        },
    }
})